module.exports = __webpack_public_path__ + "static/img/model-like.e1cb134.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-like.png
// module id = jCKa
// module chunks = 36